var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 53.5L101 45.5C99.5 44 98.5 41 98.5 39V31C98.5 25.5 94 21.5 89 21.5H80.5C78.5 21.5 75.5 20.5 74 19L66 12C62.5 9 57 9 53.5 12L46 19C44.5 20.5 41.5 21.5 39.5 21.5H31C25.5 21.5 21.5 26 21.5 31V39.5C21.5 41.5 20.5 44.5 19 46L12.5 54C9.5 57.5 9.5 63 12.5 66.5L19 74.5C20.5 76 21.5 79 21.5 81V89.5C21.5 95 26 99 31 99H39.5C41.5 99 44.5 100 46 101.5L54 108.5C57.5 111.5 63 111.5 66.5 108.5L74.5 101.5C76 100 79 99 81 99H89.5C95 99 99 94.5 99 89.5V81C99 79 100 76 101.5 74.5L108.5 66.5C111 63 111 57 108 53.5ZM81 50.5L57 74.5C56.5 75 55.5 75.5 54.5 75.5C53.5 75.5 52.5 75 52 74.5L40 62.5C38.5 61 38.5 58.5 40 57C41.5 55.5 44 55.5 45.5 57L55 66.5L75.5 45C77 43.5 79.5 43.5 81 45C82.5 46.5 82.5 49 81 50.5Z",
    fill: "#32BC69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.5cfdf33a2c49d3d0706ebf0bb6d8ba34.svg";
export { ForwardRef as ReactComponent };